/**
 * Mobile sticky ATC bar: show when main #product-add-to-cart leaves viewport.
 */
(function () {
  if (window.__dunteryStickyAtcBound) return;
  window.__dunteryStickyAtcBound = true;

  var MOBILE_MQ = '(max-width: 749px)';
  var intersectionObserver = null;
  var buttonObserver = null;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function getSticky() {
    return document.querySelector('[data-sticky-atc]');
  }

  function getMainButton() {
    return document.getElementById('product-add-to-cart');
  }

  function setChatOffset(active) {
    var offset = 'calc(7.6rem + env(safe-area-inset-bottom, 0px))';
    var nodes = document.querySelectorAll(
      '#dummy-chat-button-iframe, #ShopifyChat, #shopify-chat, .shopify-chat, iframe[title*="Chat"], iframe[title*="chat"]'
    );
    nodes.forEach(function (el) {
      if (active) {
        el.style.setProperty('bottom', offset, 'important');
      } else {
        el.style.removeProperty('bottom');
      }
    });
  }

  function setVisible(sticky, visible) {
    if (!sticky) return;
    if (!isMobile()) {
      sticky.hidden = true;
      document.documentElement.classList.remove('is-sticky-atc-visible');
      setChatOffset(false);
      return;
    }
    sticky.hidden = !visible;
    document.documentElement.classList.toggle('is-sticky-atc-visible', visible);
    setChatOffset(visible);
  }

  function getMainLabelText(main) {
    var mainLabel = main.querySelector('[data-label-add]');
    if (!mainLabel) {
      var spans = main.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        if (!spans[i].closest('.loading-overlay__spinner')) {
          mainLabel = spans[i];
          break;
        }
      }
    }
    return mainLabel ? mainLabel.textContent.trim() : '';
  }

  function syncButtonState() {
    var sticky = getSticky();
    var main = getMainButton();
    if (!sticky || !main) return;

    var submit = sticky.querySelector('[data-sticky-atc-submit]');
    var label = sticky.querySelector('[data-sticky-atc-label]');
    if (!submit) return;

    var disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    var loading = main.classList.contains('loading');
    var nextDisabled = disabled || loading;
    if (submit.disabled !== nextDisabled) {
      submit.disabled = nextDisabled;
    }

    if (label && !loading) {
      // Prefer short sticky label when available; use main label for sold-out/unavailable.
      var stickyAdd = label.getAttribute('data-label-add') || '';
      var mainText = getMainLabelText(main);
      var nextText = disabled
        ? mainText || stickyAdd || 'ADD TO BAG'
        : stickyAdd || mainText || 'ADD TO BAG';
      if (label.textContent !== nextText) {
        label.textContent = nextText;
      }
    }
  }

  function syncPrice() {
    var sticky = getSticky();
    if (!sticky) return;
    var sectionId = sticky.getAttribute('data-section-id');
    var mainPrice = sectionId ? document.getElementById('price-' + sectionId) : null;
    var stickyPrice = sticky.querySelector('[data-sticky-atc-price]');
    if (!mainPrice || !stickyPrice) return;

    var source = mainPrice.querySelector('.price') || mainPrice;
    var onSale = source.classList.contains('price--on-sale');
    var moneyEl = onSale
      ? source.querySelector('.price__sale .price-item--sale')
      : source.querySelector('.price__regular .price-item--regular');
    if (!moneyEl) {
      moneyEl =
        source.querySelector('.price-item--sale') ||
        source.querySelector('.price-item--regular');
    }
    if (!moneyEl) return;

    var nextHtml =
      '<div class="price price--sticky"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">' +
      moneyEl.innerHTML +
      '</span></div></div></div>';
    if (stickyPrice.innerHTML !== nextHtml) {
      stickyPrice.innerHTML = nextHtml;
    }
  }

  function bindButtonObserver(main) {
    if (buttonObserver) {
      buttonObserver.disconnect();
      buttonObserver = null;
    }
    if (!main) return;

    buttonObserver = new MutationObserver(function () {
      syncButtonState();
    });
    buttonObserver.observe(main, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function bindObserver() {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = null;
    }

    var sticky = getSticky();
    var main = getMainButton();
    if (!sticky || !main) return;

    bindButtonObserver(main);

    if (!isMobile()) {
      setVisible(sticky, false);
      return;
    }

    intersectionObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        setVisible(sticky, !entry.isIntersecting);
        syncButtonState();
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -8px 0px'
      }
    );

    intersectionObserver.observe(main);
    syncButtonState();
  }

  function onStickyClick(event) {
    var btn = event.target.closest('[data-sticky-atc-submit]');
    if (!btn) return;
    event.preventDefault();
    var main = getMainButton();
    if (!main || main.disabled || main.classList.contains('loading')) return;
    main.click();
  }

  document.addEventListener('click', onStickyClick);

  document.addEventListener('product:ajax-loaded', function () {
    window.requestAnimationFrame(function () {
      bindObserver();
      syncPrice();
      syncButtonState();
    });
  });

  window.addEventListener('resize', function () {
    bindObserver();
  });

  window.dunterySyncStickyAtc = function () {
    syncPrice();
    syncButtonState();
  };

  function boot() {
    bindObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
